"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionType = void 0;
var ActionType;
(function (ActionType) {
    ActionType["PAUSE"] = "PAUSE";
    ActionType["UPDATE_TIME"] = "UPDATE_TIME";
    ActionType["UPDATE_URL"] = "UPDATE_URL";
    ActionType["PLAY"] = "PLAY";
    ActionType["UPDATE_KEY"] = "UPDATE_KEY";
    ActionType["UPDATE_SIZE"] = "UPDATE_SIZE";
    ActionType["RELOAD"] = "RELOAD";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
//# sourceMappingURL=types.js.map